import {
    GET_PUSAT_OVERVIEW,
    GET_PUSAT_OVERVIEW_SUCCESS,
    GET_PUSAT_OVERVIEW_FAIL,
    GET_PROVINSI_OVERVIEW,
    GET_PROVINSI_OVERVIEW_SUCCESS,
    GET_PROVINSI_OVERVIEW_FAIL,
    GET_KABKOT_OVERVIEW,
    GET_KABKOT_OVERVIEW_SUCCESS,
    GET_KABKOT_OVERVIEW_FAIL,
    GET_KECAMATAN_OVERVIEW,
    GET_KECAMATAN_OVERVIEW_SUCCESS,
    GET_KECAMATAN_OVERVIEW_FAIL,

    GET_DOKUMEN_PROVINSI,
    GET_DOKUMEN_PROVINSI_SUCCESS,
    GET_DOKUMEN_PROVINSI_FAIL,
    GET_DOKUMEN_KABKOT,
    GET_DOKUMEN_KABKOT_SUCCESS,
    GET_DOKUMEN_KABKOT_FAIL,
    GET_DOKUMEN_KECAMATAN,
    GET_DOKUMEN_KECAMATAN_SUCCESS,
    GET_DOKUMEN_KECAMATAN_FAIL,
  } from "./actionTypes";
  import { API } from "../../API/api";
  
  // get exco table
  export const getJumlahPusatOverview = () => (dispatch) => {
    dispatch({
      type: GET_PUSAT_OVERVIEW,
    });
  
    const request = API.getJumlahPusatOverview();
    return request.then(
      (response) => dispatch(getJumlahPusatOverviewSuccess(response.data)),
      (err) => dispatch(getJumlahPusatOverviewFail(err))
    );
  };
  
  export const getJumlahPusatOverviewSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_PUSAT_OVERVIEW_SUCCESS,
      payload: data,
    });
  };
  
  export const getJumlahPusatOverviewFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_PUSAT_OVERVIEW_FAIL,
      payload: data,
    });
  };

  export const getJumlahProvinsiOverview = () => (dispatch) => {
    dispatch({
      type: GET_PROVINSI_OVERVIEW,
    });
  
    const request = API.getJumlahProvinsiOverview();
    return request.then(
      (response) => dispatch(getJumlahProvinsiOverviewSuccess(response.data)),
      (err) => dispatch(getJumlahProvinsiOverviewFail(err))
    );
  };
  
  export const getJumlahProvinsiOverviewSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_PROVINSI_OVERVIEW_SUCCESS,
      payload: data,
    });
  };
  
  export const getJumlahProvinsiOverviewFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_PROVINSI_OVERVIEW_FAIL,
      payload: data,
    });
  };

  export const getJumlahKabkotOverview = () => (dispatch) => {
    dispatch({
      type: GET_KABKOT_OVERVIEW,
    });
  
    const request = API.getJumlahKabkotOverview();
    return request.then(
      (response) => dispatch(getJumlahKabkotOverviewSuccess(response.data)),
      (err) => dispatch(getJumlahKabkotOverviewFail(err))
    );
  };
  
  export const getJumlahKabkotOverviewSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_KABKOT_OVERVIEW_SUCCESS,
      payload: data,
    });
  };
  
  export const getJumlahKabkotOverviewFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_KABKOT_OVERVIEW_FAIL,
      payload: data,
    });
  };

  export const getJumlahKecamatanOverview = () => (dispatch) => {
    dispatch({
      type: GET_KECAMATAN_OVERVIEW,
    });
  
    const request = API.getJumlahKecamatanOverview();
    return request.then(
      (response) => dispatch(getJumlahKecamatanOverviewSuccess(response.data)),
      (err) => dispatch(getJumlahKecamatanOverviewFail(err))
    );
  };
  
  export const getJumlahKecamatanOverviewSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_KECAMATAN_OVERVIEW_SUCCESS,
      payload: data,
    });
  };
  
  export const getJumlahKecamatanOverviewFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_KECAMATAN_OVERVIEW_FAIL,
      payload: data,
    });
  };



  export const getDokumenProvinsi = (order_type,order_by,search,pemenuhan_kabkot,kelengkapan_dokumen) => (dispatch) => {
    dispatch({
      type: GET_DOKUMEN_PROVINSI,
    });
  
    const request = API.getDokumenProvinsi(order_type,order_by,search,pemenuhan_kabkot,kelengkapan_dokumen);
    return request.then(
      (response) => dispatch(getDokumenProvinsiSuccess(response.data)),
      (err) => dispatch(getDokumenProvinsiFail(err))
    );
  };
  
  export const getDokumenProvinsiSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOKUMEN_PROVINSI_SUCCESS,
      payload: data,
    });
  };
  
  export const getDokumenProvinsiFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOKUMEN_PROVINSI_FAIL,
      payload: data,
    });
  };

  export const getDokumenKabkot = (order_type,order_by,search,id_provinsi,pemenuhan_kecamatan,kelengkapan_dokumen) => (dispatch) => {
    dispatch({
      type: GET_DOKUMEN_KABKOT,
    });
  
    const request = API.getDokumenKabkot(order_type,order_by,search,id_provinsi,pemenuhan_kecamatan,kelengkapan_dokumen);
    return request.then(
      (response) => dispatch(getDokumenKabkotSuccess(response.data)),
      (err) => dispatch(getDokumenKabkotFail(err))
    );
  };
  
  export const getDokumenKabkotSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOKUMEN_KABKOT_SUCCESS,
      payload: data,
    });
  };
  
  export const getDokumenKabkotFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOKUMEN_KABKOT_FAIL,
      payload: data,
    });
  };

  export const getDokumenKecamatan = (order_type,order_by,search,id_kabkot,kelengkapan_dokumen) => (dispatch) => {
    dispatch({
      type: GET_DOKUMEN_KECAMATAN,
    });
  
    const request = API.getDokumenKecamatan(order_type,order_by,search,id_kabkot,kelengkapan_dokumen);
    return request.then(
      (response) => dispatch(getDokumenKecamatanSuccess(response.data)),
      (err) => dispatch(getDokumenKecamatanFail(err))
    );
  };
  
  export const getDokumenKecamatanSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOKUMEN_KECAMATAN_SUCCESS,
      payload: data,
    });
  };
  
  export const getDokumenKecamatanFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_DOKUMEN_KECAMATAN_FAIL,
      payload: data,
    });
  };

  